import * as React from 'react';

const DuplicateIconSvg = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <path fill="url(#a)" d="M0 0h24v24H0z" />
        <defs>
            <pattern
                id="a"
                patternContentUnits="objectBoundingBox"
                width={1}
                height={1}
            >
                <use xlinkHref="#b" transform="scale(.01042)" />
            </pattern>
            <image
                id="b"
                width={96}
                height={96}
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAACxKAAAsSgF3enRNAAABLUlEQVR4nO3dQQrCMBQA0Ua8/5Xj3o0UY56089aC0OGDP7V0zDmPOI+uvVUArABYAbACYAXACoAVACsAVgCsANhz99ePMS59+DTnHGc+3wRgBcAKgBUAKwBWAKwA2PY94JOzv6N3W73HNAFYAbACYAXACoAVACsAdnoP+PV5vr5fsHsPaQKwAmAFwAqAFQArAFYAbPn9gLud53+rCcAKgBUAKwBWAKwAWAGwAmAFwAqAFQArAFYArABYAbACYAXACoAVACsAVgCsAFgBsL97Tljb/b+hJgArAFYArABYAbACYAXA2gPe9JzwzRQAKwBWAKwAWAGwAmDL94Crvx9gtSYAKwBWAKwAWAGwAmAFwHqnPNYEYAXACoAVACsAVgCsAFgBsAJgBcAKIB3H8QJ+wxzLdenWYQAAAABJRU5ErkJggg=="
            />
        </defs>
    </svg>

);

export default DuplicateIconSvg; 